export const mutations = {
  // test
  addTestList (state, payload) {
    state.tests.push(payload)
  }
}
